export const businessesMonthlyStates = state => state.businessesMonthlyStates